import { useSuspenseQuery } from '@tanstack/react-query'

import { GetUltimosAtendimentosService } from '@/features/atendimento/shared/http'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

const DEZ_MINUTOS = 1000 * 60 * 10
export const useSuspenseUltimosAtendimentos = () => {
  return useSuspenseQuery({
    queryKey: atendimentoKeys.ultimosAtendimentos(),
    queryFn: async () => new GetUltimosAtendimentosService().execute(),
    staleTime: DEZ_MINUTOS,
  })
}
